module.exports = __webpack_public_path__ + "static/media/37-3.f018b4c9.mp3";